import getConfig from 'next/config';
const { publicRuntimeConfig } = getConfig();

export const SA_LEGAL = {
  heading: 'ClearTax is a product by Defmacro Software Pvt. Ltd.',
  heading_ar: 'كليرتاكس هو منتج من شركة ديفماكرو سوفت وير برايفيت ليميتيد.',
  privacy: 'Privacy Policy',
  privacy_ar: 'شروط استخدام وسياسة الخصوصية',
  terms: 'Terms of Use',
  terms_ar: '',
};
const company = {
  heading: '',
  heading_ar: '',
  child: [
    {
      id: 'company',
      subHead: 'Company',
      subHead_ar: 'الشركة',
      lists: [
        {
          id: 'about_us',
          text: 'About us',
          text_ar: 'نبذة عنا',
          link: `https://www.cleartax.com/sa/about-us`,
          link_ar: `https://www.cleartax.com/sa/ar/about-us`,
        },
        {
          id: 'contact_us',
          text: 'Contact us',
          text_ar: 'اتصل بنا',
          link: `https://www.cleartax.com/sa/contact-us`,
          link_ar: `https://www.cleartax.com/sa/ar/contact-us`,
        },
        {
          id: 'media_press',
          text: 'Media & Press',
          text_ar: 'وسائل الإعلام والصحافة',
          link: `https://www.cleartax.com/sa/press`,
          link_ar: `https://www.cleartax.com/sa/ar/press`,
        },
        {
          id: 'trust_safety',
          text: 'Trust & Safety',
          text_ar: 'الثقة والسلامة',
          link: 'https://cleartax.in/s/trust',
          link_ar: `https://cleartax.in/s/trust`,
        },
      ],
    },
  ],
};

const products_solutions = {
  heading: 'Products & Solutions',
  heading_ar: 'المنتجات والحلول',
  child: [
    {
      id: 'products_solutions_sa',
      subHead: 'Saudi Arabia',
      subHead_ar: 'المملكة العربية السعودية',
      lists: [
        {
          id: 'e_invoicing_software',
          text: 'E-invoicing Software',
          text_ar: 'الفوترة الإلكترونية',
          link: `https://www.cleartax.com/sa/e-invoicing-software`,
          link_ar: `https://www.cleartax.com/sa/ar/e-invoicing-software`,
        },
        {
          id: 'api_integration',
          text: 'API Integration',
          text_ar: 'التكامل',
          link: `https://www.cleartax.com/sa/e-invoicing-integration`,
          link_ar: `https://www.cleartax.com/sa/ar/e-invoicing-integration`,
        },
        {
          id: 'supply_chain_finance',
          text: 'Supply Chain Finance',
          text_ar: 'تمويل سلسلة التوريد',
          link: 'https://www.cleartax.com/sa#ksa-einvoicing-promises',
          link_ar: 'https://www.cleartax.com/sa/ar/#ksa-einvoicing-promises',
        },
        {
          id: 'account_receivable_automation',
          text: 'Account Receivable Automation',
          text_ar: 'أتمتة الحسابات الدائنة',
          link: 'https://www.cleartax.com/sa#ksa-einvoicing-promises',
          link_ar: 'https://www.cleartax.com/sa/ar/#ksa-einvoicing-promises',
        },
        {
          id: 'account_payable_automation',
          text: 'Account Payable Automation',
          text_ar: 'أتمتة الحسابات المدينة',
          link: 'https://www.cleartax.com/sa#ksa-einvoicing-promises',
          link_ar: 'https://www.cleartax.com/sa/ar/#ksa-einvoicing-promises',
        },
      ],
    },
    {
      id: 'products_solutions_in',
      subHead: 'India',
      subHead_ar: 'India',
      lists: [
        {
          id: 'clear_gst',
          text: 'Clear GST',
          text_ar: 'كلير لضريبة السلع والخدمات',
          link: 'https://cleartax.in/gst',
          link_ar: 'https://cleartax.in/gst',
        },
        {
          id: 'clear_max_itc',
          text: 'Clear Max ITC',
          text_ar: 'كلير ماكس آئى تى سي',
          link: 'https://cleartax.in/s/max-itc',
          link_ar: 'https://cleartax.in/s/max-itc',
        },
        {
          id: 'clear_tax_cloud',
          text: 'Clear Tax Cloud',
          text_ar: 'سحابة كليرتاكس',
          link: 'https://cleartax.in/s/taxcloud',
          link_ar: 'https://cleartax.in/s/taxcloud',
        },
        {
          id: 'clear_pro',
          text: 'Clear PRO',
          text_ar: 'كلير برو',
          link: 'https://cleartax.in/s/clearpro',
          link_ar: 'https://cleartax.in/s/clearpro',
        },
        {
          id: 'clear_tds',
          text: 'Clear TDS',
          text_ar: 'كلير لضريبة مخصومة من المنبع',
          link: 'https://cleartax.in/tds/',
          link_ar: 'https://cleartax.in/tds/',
        },
        {
          id: 'clearone',
          text: 'ClearOne',
          text_ar: 'كليرون',
          link: 'https://www.clear.in/clearone',
          link_ar: 'https://www.clear.in/clearone',
        },
        {
          id: 'clear_it',
          text: 'Clear IT',
          text_ar: 'ضريبة الدخل efiling',
          link: 'https://cleartax.in/income-tax-efiling',
          link_ar: 'https://cleartax.in/income-tax-efiling',
        },
        {
          id: 'clear_invest',
          text: 'Clear Invest',
          text_ar: 'كلير للاستثمار',
          link: 'https://cleartax.in/save',
          link_ar: 'https://cleartax.in/save',
        },
        {
          id: 'black',
          text: 'Black',
          text_ar: 'بلاك',
          link: 'https://play.google.com/store/apps/details?id=in.cleartax.consumer2&pli=1',
          link_ar:
            'https://play.google.com/store/apps/details?id=in.cleartax.consumer2&pli=1',
        },
      ],
    },
  ],
};

const sa_resources = {
  heading: '',
  heading_ar: '',
  child: [
    {
      id: 'resources_en',
      subHead: 'Resources',
      subHead_ar: 'المصادر',
      lists: [
        {
          id: 'webinars',
          text: 'Webinars',
          text_ar: 'الويبينار',
          link: 'https://7giy8.app.link/e/xhv1Sw085sb',
          link_ar: 'https://7giy8.app.link/e/xhv1Sw085sb',
        },
        {
          id: 'blogs',
          text: 'Blogs',
          text_ar: 'المدونات',
          link: 'https://cleartax.com/sa/ksa-einvoicing',
          link_ar: 'https://cleartax.com/sa/ar/ksa-einvoicing',
        },
      ],
    },
    {
      id: 'resources_ar',
      subHead: 'Resources (Arabic)',
      subHead_ar: 'Resources (Arabic)',
      lists: [
        {
          id: 'ksa_eivoicing',
          text: 'الفوترة الإلكترونية في المملكة العربية السعودية',
          text_ar: 'الفوترة الإلكترونية في المملكة العربية السعودية',
          link: 'https://cleartax.com/sa/ar/ksa-einvoicing',
          link_ar: 'https://cleartax.com/sa/ar/ksa-einvoicing',
        },
        {
          id: 'e-invoicing-regulations-saudi-arabia',
          text: 'لوائح الفوترة الإلكترونية في المملكة العربية السعودية',
          text_ar: 'لوائح الفوترة الإلكترونية في المملكة العربية السعودية',
          link: 'https://cleartax.com/sa/ar/e-invoicing-regulations-saudi-arabia',
          link_ar:
            'https://cleartax.com/sa/ar/e-invoicing-regulations-saudi-arabia',
        },
        {
          id: 'e-invoice-types-saudi-arabia',
          text: 'أنواع الفوترة الإلكترونية في المملكة العربية السعودية',
          text_ar: 'أنواع الفوترة الإلكترونية في المملكة العربية السعودية',
          link: 'https://cleartax.com/sa/ar/e-invoice-types-saudi-arabia',
          link_ar: 'https://cleartax.com/sa/ar/e-invoice-types-saudi-arabia',
        },
        {
          id: 'phase-1-e-invoicing-saudi-arabia',
          text: 'المرحلة الأولى للفوترة الإلكترونية في المملكة العربية السعودية',
          text_ar:
            'المرحلة الأولى للفوترة الإلكترونية في المملكة العربية السعودية',
          link: 'https://cleartax.com/sa/ar/phase-1-e-invoicing-saudi-arabia',
          link_ar:
            'https://cleartax.com/sa/ar/phase-1-e-invoicing-saudi-arabia',
        },
        {
          id: 'generate-qr-code-e-invoice-ksa',
          text: 'إنشاء رمز الاستجابة السريعة للفوترة الإلكترونية في المملكة العربية السعودية',
          text_ar:
            'إنشاء رمز الاستجابة السريعة للفوترة الإلكترونية في المملكة العربية السعودية',
          link: 'https://cleartax.com/sa/ar/generate-qr-code-e-invoice-ksa',
          link_ar: 'https://cleartax.com/sa/ar/generate-qr-code-e-invoice-ksa',
        },
      ],
    },
    {
      id: 'calculators',
      subHead: 'Calculators',
      subHead_ar: 'Calculators',
      lists: [
        {
          id: 'vat_calculator',
          text: 'Vat Calculator',
          text_ar: 'حاسبة ضريبة القيمة المضافة',
          link: 'https://cleartax.com/sa/vat-calculator',
          link_ar: 'https://cleartax.com/sa/ar/vat-calculator',
        },
      ],
    },
  ],
};

const why_cleartax = {
  heading: '',
  heading_ar: '',
  child: [
    {
      id: 'why_cleartax',
      subHead: 'Why Cleartax',
      subHead_ar: 'لماذا كليرتاكس',
      lists: [
        {
          id: 'for_business',
          text: 'For Business',
          text_ar: 'للأعمال',
          link: 'https://www.cleartax.com/sa/business',
          link_ar: 'https://www.cleartax.com/sa/ar/business',
        },
        {
          id: 'for_partners',
          text: 'For Partners',
          text_ar: 'للشركاء فقط',
          link: 'https://www.cleartax.com/sa/partners',
          link_ar: 'https://www.cleartax.com/sa/ar/partners',
        },
      ],
    },
  ],
};

const products = {
  heading: 'Products',
  child: [
    {
      id: 'products_individuals',
      subHead: 'Individuals',
      lists: [
        {
          id: 'income_tax_efiling',
          text: 'Income Tax e Filing',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/income-tax-efiling`,
        },
        {
          id: 'taxPlanning',
          text: 'Tax Planning',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/planning`,
        },
      ],
    },
    {
      id: 'products_income_tax_filing',
      subHead: 'Income Tax Filing',
      lists: [
        {
          id: 'income_tax_app',
          text: 'Income Tax App android',
          link: 'https://play.google.com/store/apps/details?id=in.cleartax.consumer2',
        },
        {
          id: 'income_tax',
          text: 'Income Tax',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/income-tax`,
        },
        {
          id: 'section_80_deduction',
          text: 'Secion 80 Deductions',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/80c-80-deductions`,
        },
        {
          id: 'income_tax_nri',
          text: 'Income tax for NRI',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/income-tax-for-nri`,
        },
      ],
    },
    {
      id: 'products_clear_gst',
      subHead: 'ClearGST',
      lists: [
        {
          id: 'gst',
          text: 'GST',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/gst-law-goods-and-services-tax`,
        },
        {
          id: 'gst_login',
          text: 'GST Login',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/cleartax-guide-on-gst-portal`,
        },
        {
          id: 'gst_software',
          text: 'GST software',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/gst`,
        },
        {
          id: 'new_gst_returns',
          text: 'New GST returns',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/new-gst-returns`,
        },
        {
          id: 'e_invoicing',
          text: 'e-invoicing',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/e-invoicing-gst`,
        },
        {
          id: 'input_tax_credit',
          text: 'Input tax credit',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/gst-input-tax-credit`,
        },
      ],
    },
    {
      id: 'products_enterprise',
      subHead: 'Enterprises',
      lists: [
        {
          id: 'clear_gst',
          text: 'ClearGST',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/gst`,
        },
        {
          id: 'eway_bill',
          text: 'ClearE-Waybill',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/gst-eway-bill-software`,
        },
        {
          id: 'einvoicing_software',
          text: 'e-Invoicing Software',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/e-invoicing-enterprise-software`,
        },
        {
          id: 'tds',
          text: 'ClearTDS',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/tds`,
        },
        {
          id: 'eway_bill_registration',
          text: 'eWay Bill Registration',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/gst-eway-bill-registration`,
        },
      ],
    },
    {
      id: 'products_ca',
      subHead: 'CAs',
      lists: [
        {
          text: 'CA partner program',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/ca-partner`,
        },
        {
          text: 'ClearGST',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/gst`,
        },
        {
          text: 'ClearTDS',
          link: 'https://cleartds.com/',
        },
        {
          text: 'ClearTaxCloud',
          link: 'https://taxcloudindia.com/',
        },
        {
          text: 'ClearPro App',
          link: 'https://play.google.com/store/apps/details?id=in.cleartax.pro',
        },
      ],
    },
    {
      id: 'products_sme',
      subHead: 'SMEs',
      lists: [
        {
          text: 'ClearGST',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/gst`,
        },
        {
          text: 'ClearOne',
          link: 'https://www.clear.in/clearone/?utm_content=https://cleartax.in/s/gstr-1&utm_term=gst_gst-returns&cta_type=others&anonid=368e7650-572f-4510-9a90-e11644967a66',
        },
        {
          text: 'Billing Software',
          link: 'https://www.clear.in/clearone/billing-software/?utm_content=https://cleartax.in/s/gstr-1&utm_term=gst_gst-returns&cta_type=others&anonid=368e7650-572f-4510-9a90-e11644967a66',
        },
        {
          text: 'Invoicing Software',
          link: 'https://www.clear.in/clearone/invoicing-software/?utm_content=https://cleartax.in/s/gstr-1&utm_term=gst_gst-returns&cta_type=others&anonid=368e7650-572f-4510-9a90-e11644967a66',
        },
        {
          text: 'Services for businesses',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/services/business/c`,
        },
        {
          text: 'ClearOne App',
          link: 'https://play.google.com/store/apps/details?id=in.cleartax.clearone',
        },
      ],
    },
    {
      id: 'products_clear_services',
      subHead: 'ClearServices',
      lists: [
        {
          text: 'Tax filing for professionals',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/presumptive-tax-for-professionals`,
        },
        {
          text: 'Tax filing for traders',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/tax-filing-for-traders`,
        },
      ],
    },
    {
      id: 'products_hsn_lookup',
      subHead: 'HSN Lookup',
      lists: [
        {
          text: 'HSN Code Finder',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/gst-hsn-lookup`,
        },
        {
          text: 'Cement HSN Code',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/chapter-25-mineral-products-salt-sulphur-earths-stone-plastering-materials-lime-cement-gst-rate-hsn-code`,
        },
        {
          text: 'Transport HSN Code',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/chapter-99-services-sac-code-gst-rate`,
        },
        {
          text: 'Plastic HSN Code',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/chapter-39-plastics-gst-rate-hsn-code`,
        },
        {
          text: 'Cloth GST Rate',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/chapter-61-apparel-clothing-accessories-knitted-crocheted-gst-rate-hsn-code`,
        },
        {
          text: 'Books GST Rate',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/chapter-49-printed-books-newspapers-pictures-manuscripts-typescripts-plans-gst-rate-hsn-code`,
        },
      ],
    },
  ],
};

const resources = {
  heading: 'Resources & Guides',
  child: [
    {
      id: 'resources_gst',
      subHead: 'GST Resources',
      lists: [
        {
          text: 'GST Registration',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/gst-registration/`,
        },
        {
          text: 'GST Returns',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/gst-returns`,
        },
        {
          text: 'GST Procedure',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/gst-procedure`,
        },
        {
          text: 'GST News & Announcement',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/gst-news-and-announcements`,
        },
        {
          text: 'GSTR 9 Annual Returns',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/gstr-9-annual-return`,
        },
        {
          text: 'GST Payments & Refunds',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/gst-payments-and-refunds`,
        },
        {
          text: 'Invoicing Under GST',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/gst-invoice`,
        },
        {
          text: 'GSTR-2B',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/gstr-2b`,
        },
        {
          text: 'GSTR-3B',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/gstr-3b`,
        },
      ],
    },
    {
      id: 'resources_itr',
      subHead: 'ITR Resources',
      lists: [
        {
          text: 'Income Tax Slab',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/income-tax-slabs`,
        },
        {
          text: 'Form 26AS',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/view-form-26as-tax-credit-statement`,
        },
        {
          text: 'What is Form 16',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/what-is-form-16`,
        },
        {
          text: 'Salary Income',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/salary-income`,
        },
        {
          text: 'How to File TDS Returns',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/tds/guides`,
        },
        {
          text: 'New Income Tax Portal',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/new-income-tax-portal`,
        },
        {
          text: 'Incometax.gov.in',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/incometax-gov-in`,
        },
        {
          text: 'Income from Selling Shares',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/taxation-on-income-earned-from-selling-shares`,
        },
        {
          text: 'Income Tax Due Dates',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/due-date-tax-filing`,
        },
      ],
    },
    {
      id: 'resources_mutual_fund',
      subHead: 'Mutual Fund Resources',
      lists: [
        {
          text: 'How to Invest in Mutual Funds',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/never-invested-mutual-funds-heres-begin`,
        },
        {
          text: 'Mutual fund Types',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/mutual-fund-types`,
        },
        {
          text: 'ELSS',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/elss`,
        },
        {
          text: 'SIP Mutual Funds',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/sip`,
        },
        {
          text: 'Hedge Funds',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/hedge-funds`,
        },
        {
          text: 'Debt Funds',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/debt-funds`,
        },
        {
          text: 'NFO',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/new-fund-offer-nfo`,
        },
        {
          text: 'What is AMFI',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/association-mutual-funds-india-amfi`,
        },
        {
          text: 'What is NAV',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/nav-important-selecting-mutual-fund`,
        },
      ],
    },
    {
      id: 'resources_business',
      subHead: 'Business Resources',
      lists: [
        {
          text: 'Memorandum of Understanding (MoU)',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/memorandum-understanding-mou-format-download/`,
        },
        {
          text: 'Mudra Yojana',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/mudra-yojana/`,
        },
        {
          text: 'Inflation & Deflation',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/inflation-deflation/`,
        },
        {
          text: 'Loan Agreement',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/loan-agreement-format-download/`,
        },
        {
          text: 'Succession Certificate',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/succession-certificate-format/`,
        },
        {
          text: 'Solvency Certificate',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/solvency-certificate-format-download/`,
        },
        {
          text: 'Debt Settlement Agreement',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/debt-settlement-agreement/`,
        },
        {
          text: 'Rental Agreement',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/rental-agreement-format-download`,
        },
        {
          text: 'Letters Of Credit',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/letters-of-credit/`,
        },
      ],
    },
  ],
};

const tools = {
  heading: 'Tools',
  child: [
    {
      id: 'tools_set1',
      subHead: '',
      lists: [
        {
          text: 'Income tax calculator',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/paytax/taxCalculator`,
        },
        {
          text: 'EMI Calculator',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/emi-calculator`,
        },
        {
          text: 'Mutual fund calculator',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/mutual-fund-calculator`,
        },
        {
          text: 'HSN Code Finder',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/gst-hsn-lookup`,
        },
        {
          text: 'SIP calculator',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/save/sip-calculator`,
        },
        {
          text: 'GST calculator',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/gst-calculator`,
        },
      ],
    },
    {
      id: 'tools_set2',
      subHead: '',
      lists: [
        {
          text: 'PPF Calculator',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/ppf-calculator`,
        },
        {
          text: 'GST number search',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/gst-number-search/`,
        },
        {
          text: 'IFSC Code Search',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/ifsc-code/`,
        },
        {
          text: 'Generate rent receipts',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/save/rent`,
        },
        {
          text: 'Home Loan EMI Calculator',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/home-loan-emi-calculator`,
        },
        {
          text: 'NPS Calculator',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/nps-calculator`,
        },
      ],
    },
    {
      id: 'tools_set3',
      subHead: '',
      lists: [
        {
          text: 'HRA calculator',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/paytax/hraCalculator`,
        },
        {
          text: 'RD Calculator',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/rd-calculator`,
        },
        {
          text: 'FD Calculator',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/fd-calculator`,
        },
        {
          text: 'Gold Rates Today',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/f/gold-rate/india`,
        },
        {
          text: 'Currency Converter',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/currency/currency-converter`,
        },
        {
          text: 'Compound Interest Calculator',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/compound-interest-calculator`,
        },
      ],
    },
    {
      id: 'tools_set4',
      subHead: '',
      lists: [
        {
          text: 'Find HSN code',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/gst-hsn-lookup`,
        },
        {
          text: 'Tax Saving Calculator',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/tax-saving-calculator`,
        },
        {
          text: 'Get IT refund status',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/check-status-income-tax-refund`,
        },
        {
          text: 'Salary Calculator',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/salary-calculator`,
        },
        {
          text: 'EPF Calculator',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/pf-calculator`,
        },
        {
          text: 'GST Number Search by Name',
          link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/gst-number-search-by-name`,
        },
      ],
    },
  ],
};

const trendingMutualFunds = {
  heading: 'TRENDING MUTUAL FUNDS',
  lists: [
    {
      text: 'ICICI Prudential Technology Fund Direct Plan Growth',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/mutual-funds/icici-prudential-mutual-fund/icici-pru-technology-direct/INF109K01Z48`,
    },
    {
      text: 'Tata Digital India Fund Direct Growth',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/mutual-funds/tata-mutual-fund/tata-digital-india-direct/INF277K01Z77`,
    },
    {
      text: 'Axis Bluechip Fund Growth',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/mutual-funds/axis/axis-bluechip-fund/INF846K01164`,
    },
    {
      text: 'ICICI Prudential Technology Fund Growth',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/mutual-funds/icici-prudential-mutual-fund/icici-pru-technology/INF109K01506`,
    },
    {
      text: 'Aditya Birla Sun Life Tax Relief 96 Growth',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/mutual-funds/birla-sun-life-mutual-fund/aditya-bsl-tax-relief-96/INF209K01108?ref=dashboard`,
    },
    {
      text: 'Aditya Birla Sun Life Digital India Fund Direct Plan Growth',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/mutual-funds/birla-sun-life-mutual-fund/aditya-bsl-digital-india-direct/INF209K01VF2`,
    },
    {
      text: 'Quant Tax Plan Growth Option Direct Plan',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/mutual-funds/quant-money-mutual-fund/quant-tax-plan-direct/INF966L01986`,
    },
    {
      text: 'SBI Technology Opportunities Fund Direct Growth',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/mutual-funds/sbi-mutual-fund/sbi-technology-opportunities-direct/INF200K01RV6`,
    },
    {
      text: 'Axis Long Term Equity Fund Growth',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/mutual-funds/axis-mutual-fund/axis-long-term-equity-fund/INF846K01131?ref=dashboard`,
    },
  ],
};

const topAMC = {
  heading: 'TOP AMCS',
  lists: [
    {
      text: 'SBI Mutual Fund',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/mf/sbi-mutual-fund`,
    },
    {
      text: 'Nippon India mutual fund',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/mutual-funds/nippon-india-mutual-fund`,
    },
    {
      text: 'HDFC Mutual Fund',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/mf/hdfc-mutual-fund`,
    },
    {
      text: 'UTI mutual fund',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/mf/uti-mutual-fund`,
    },
    {
      text: 'Kotak Mahindra Mutual Fund',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/mutual-funds/kotak-mutual-fund`,
    },
    {
      text: 'ICICI Prudential Mutual Fund',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/mf/icici-prudential-mutual-fund`,
    },
    {
      text: 'Aditya Birla Mutual Fund',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/mf/birla-sun-life-mutual-fund`,
    },
    {
      text: 'Axis mutual fund',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/mf/axis-mutual-fund`,
    },
  ],
};

const stockMarkets = {
  heading: 'STOCK MARKETS',
  lists: [
    {
      text: 'Stock Market Live',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/stocks/`,
    },
    {
      text: 'Yes Bank Share Price',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/stocks/yes-bank-ltd/`,
    },
    {
      text: 'SBI Share Price',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/stocks/state-bank-of-india/`,
    },
    {
      text: 'IRCTC Share Price',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/stocks/indian-railway-catering-tourism-corporation-ltd/`,
    },
    {
      text: 'ITC Share Price',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/stocks/itc-ltd/`,
    },
    {
      text: 'TCS Share Price',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/stocks/tata-consultancy-services-ltd/`,
    },
    {
      text: 'Tata Motors Share Price',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/stocks/tata-motors-ltd/`,
    },
    {
      text: 'Infosys Share Price',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/stocks/infosys-ltd/`,
    },
    {
      text: 'Idea Share Price',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/stocks/vodafone-idea-ltd/`,
    },
    {
      text: 'HDFC Bank Share Price',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/stocks/hdfc-bank-ltd/`,
    },
  ],
};

const bestFunds = {
  heading: 'BEST FUNDS',
  lists: [
    {
      text: 'Best Mutual Funds',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/best-mutual-funds-india`,
    },
    {
      text: 'Best Tax Savings Mutual Funds',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/best-elss-mutual-funds`,
    },
    {
      text: 'Best Index Funds',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/best-index-funds-india`,
    },
    {
      text: 'Best Equity Mutual Funds',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/best-equity-mutual-funds`,
    },
  ],
};

export const COMPANY = {
  heading: 'Company',
  lists: [
    {
      id: 'about_us',
      text: 'About us',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/about-us`,
    },
    {
      id: 'contact_us',
      text: 'Contact us',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/meta/contact`,
    },
    {
      id: 'careers',
      text: 'Careers',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/careers`,
    },
    {
      id: 'media_press',
      text: 'Media & Press',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/meta/press`,
    },
    {
      id: 'user_reviews',
      text: 'User reviews',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/meta/reviews`,
    },
    {
      id: 'engineering_blog',
      text: 'Engineering blog',
      link: 'https://medium.com/cleartax-engineering',
    },
    {
      id: 'clear_library',
      text: 'Clear Library',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/v/tax-library/`,
    },
    {
      id: 'fintech_glossary',
      text: 'FinTech glossary',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/g/terms/`,
    },
    {
      id: 'cleartax_chronicles',
      text: 'ClearTax Chronicles',
      link: 'https://news.cleartax.in/',
    },
    {
      id: 'gst_product_guides',
      text: 'GST Product Guides',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/gst-product-guides`,
    },
    {
      id: 'trust_safety',
      text: 'Trust & Safety',
      link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/trust`,
    },
    {
      id: 'cleartax_saudi',
      text: 'Cleartax(Saudi Arabia)',
      link: 'https://www.cleartax.com/ksa/e-invoicing-software',
    },
  ],
};

export const QUERY = {
  heading: 'Have a query?',
  heading_ar: 'هل لديك استفسار ؟',
  lists: [
    {
      id: 'support',
      text: 'Support',
      text_ar: 'اتصل بنا للمساعدة',
      link: `${publicRuntimeConfig.BASE_URL.source}/contact-us`,
    },
  ],
};

export const FOLLOW_US = {
  heading: 'Follow us on',
  heading_ar: 'تابع كل من',
  images: [
    {
      imageLink:
        'https://assets1.cleartax-cdn.com/cleartax/images/1661151748_facebook.png',
      altText: 'Facebook',
      redirectUrl: 'https://www.facebook.com/clearfromcleartax',
    },
    {
      imageLink:
        'https://assets1.cleartax-cdn.com/cleartax/images/1661151759_twitter.png',
      altText: 'Twitter',
      redirectUrl: 'https://twitter.com/_cleartax',
    },
    {
      imageLink:
        'https://assets1.cleartax-cdn.com/cleartax/images/1661151768_linkedin.png',
      altText: 'LinkedIn',
      redirectUrl: 'https://www.linkedin.com/company/cleartaxindia/',
    },
    {
      imageLink:
        'https://assets1.cleartax-cdn.com/cleartax/images/1661151773_github.png',
      altText: 'GitHub',
      redirectUrl: 'https://github.com/ClearTax',
    },
    {
      imageLink:
        'https://assets1.cleartax-cdn.com/cleartax/images/1661151778_instagram.png',
      altText: 'Instagram',
      redirectUrl: 'https://www.instagram.com/clearfromcleartax/',
    },
  ],
};

export const FOOTER_DESC = [
  'Clear offers taxation & financial solutions to individuals, businesses, organizations & chartered accountants in India. Clear serves 1.5+ Million happy customers, 20000+ CAs & tax experts & 10000+ businesses across India.',
  'Efiling Income Tax Returns(ITR) is made easy with Clear platform. Just upload your form 16, claim your deductions and get your acknowledgment number online. You can efile income tax return on your income from salary, house property, capital gains, business & profession and income from other sources. Further you can also file TDS returns, generate Form-16, use our Tax Calculator software, claim HRA, check refund status and generate rent receipts for Income Tax Filing.',
  'CAs, experts and businesses can get GST ready with Clear GST software & certification course. Our GST Software helps CAs, tax experts & business to manage returns & invoices in an easy manner. Our Goods & Services Tax course includes tutorial videos, guides and expert assistance to help you in mastering Goods and Services Tax. Clear can also help you in getting your business registered for Goods & Services Tax Law.',
  'Save taxes with Clear by investing in tax saving mutual funds (ELSS) online. Our experts suggest the best funds and you can get high returns by investing directly or through SIP. Download Black by ClearTax App to file returns from your mobile phone.',
  'Office Address - Defmacro Software Private Limited, C 245A, Ground floor, Room No 1, Vikas Puri, West Delhi, New Delhi, Delhi 110018, India',
];

export const CERTIFICATION = [
  {
    image:
      'https://assets1.cleartax-cdn.com/cleartax/images/1661151452_image1361.png',
    imageWidth: '40',
    imageHeight: '40',
    altText: 'ISO',
    texts: ['ISO 27001', 'Data Center'],
  },
  {
    image:
      'https://assets1.cleartax-cdn.com/cleartax/images/1661151739_ssl.png',
    imageWidth: '56',
    imageHeight: '32',
    altText: 'SSL',
    texts: ['SSL Certified Site', '128-bit encryption'],
  },
];

export const FOOTER_COL_SETS = [products, resources, tools];

export const SA_FOOTER_COL_SETS = [
  company,
  products_solutions,
  sa_resources,
  why_cleartax,
];

export const FOOTER_BUTTON_SETS = [
  trendingMutualFunds,
  topAMC,
  stockMarkets,
  bestFunds,
];
